"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnergyTapping = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var DecreaseAnyProduction_1 = require("../../deferredActions/DecreaseAnyProduction");
var CardRenderer_1 = require("../render/CardRenderer");
var EnergyTapping = (function (_super) {
    __extends(EnergyTapping, _super);
    function EnergyTapping() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ENERGY_TAPPING,
            tags: [Tags_1.Tags.ENERGY],
            cost: 3,
            metadata: {
                cardNumber: '201',
                description: 'Decrease any Energy production 1 step and increase your own 1 step.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.minus().energy(1).any.br;
                        pb.plus().energy(1);
                    });
                }),
                victoryPoints: -1,
            },
        }) || this;
    }
    EnergyTapping.prototype.canPlay = function (player) {
        this.warning = undefined;
        if (_super.prototype.canPlay.call(this, player) && player.game.someoneElseHasResourceProduction(Resources_1.Resources.ENERGY, 1, player) === false) {
            this.warning = 'You will have to decrease your own energy production because no other player has enough.';
        }
        return true;
    };
    EnergyTapping.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        player.game.defer(new DecreaseAnyProduction_1.DecreaseAnyProduction(player, Resources_1.Resources.ENERGY, 1));
        return undefined;
    };
    EnergyTapping.prototype.getVictoryPoints = function () {
        return -1;
    };
    return EnergyTapping;
}(Card_1.Card));
exports.EnergyTapping = EnergyTapping;
//# sourceMappingURL=EnergyTapping.js.map